/* @flow */

import React from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import Wrapper from "components/Wrapper";
import { useTranslate } from "@awardit/react-use-translate";
import { HttpNotFound } from "@crossroads/express-utils";

const NotFound = (): React$Node => {
  const t = useTranslate();

  return (
    <Wrapper variant="pageWrapper" className="awardit-pageWrapper">
      <Helmet title={t("404.TITLE")} />

      <h1>{t("404.TITLE")}</h1>
      <h2>{t("404.BACK")} <Link to="/">{t("404.BACK_LINK")}</Link>?</h2>
      <HttpNotFound />
    </Wrapper>
  );
};

export default NotFound;
